// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__formItemMono___jPhWZ {
  margin-bottom: 16px;
}

.styles__label___eZfKq {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
  color: #495057;
  font-size: 14px;
}

.styles__select___Anre4 {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Number/Statusdialog/styles.css"],"names":[],"mappings":"AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EAEE,sBAAsB;AACxB","sourcesContent":["@value helpers: 'styles/helpers.css';\n\n.formItemMono {\n  margin-bottom: 16px;\n}\n\n.label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #495057;\n  font-size: 14px;\n}\n\n.select {\n  composes: select from helpers;\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"formItemMono": `styles__formItemMono___jPhWZ`,
	"label": `styles__label___eZfKq`,
	"select": `styles__select___Anre4 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["select"]}`
};
export default ___CSS_LOADER_EXPORT___;
